module.exports = __webpack_public_path__ + "static/img/far2_active.aba63b91.png";